export const defaultPages = [
  {
    id: 1,
    code: 'REPORT_COVER',
    name: 'Portada del reporte',
    description: 'Contenido que se mostrará en la primera página del reporte como portada. Puede incluir elementos visuales como imágenes, títulos, subtítulos o descripciones introductorias del proyecto.',
    visible: true,
    isUserManaged: false,
    isEditable: false,
    settings: {
      title: null,
      subtitle: null,
      description: null,
      image_cover: {
        type: 'file', // 'file' o 'url'
        name: null,
        mimeType: null,
        url: null, // si es remoto
        file: null, // si aún no ha sido subido o estás usando URL
      },
    },
    type: 'custom',
    customizationType: 'admin-only',
  },
  {
    id: 2,
    code: 'RAG_SUMMARY',
    name: 'Página de resumen de avance por grupos',
    description: 'Visualización consolidada del progreso de cada grupo del proyecto. Incluye una gráfica de barras comparando el avance programado y el avance real, junto con una tabla detallada que muestra información clave como fechas de inicio y finalización, porcentajes de ejecución y otros indicadores de seguimiento.',
    visible: true,
    isUserManaged: false,
    isEditable: false,
    settings: {
      showGroupProgress: 'parent',
      canDisableSection: false,
      customGroups: [],
    },
    type: 'custom',
    customizationType: 'admin-only',
  },

  {
    id: 3,
    code: 'LINE_SELECTOR',
    name: 'selector de lineas',
    description: 'permite seleccionar las lineas que se quieren ver en la grafica de avance por grupos',
    visible: true,
    isUserManaged: false,
    isEditable: false,
    settings: {
      baseLine: true,
      lastPlanned: true,
      actual: true,
    },
    type: 'custom',
    customizationType: 'admin-only',
  },
  {
    id: 4,
    code: 'TASK_COLUMNS_SELECTOR',
    name: 'Selector de columnas tabla de tareas',
    description: 'permite seleccionar las columnas que se quieren ver en la tabla de tareas( fechas linea base,fechas ultimo programacion, fechas Reales, progreso)',
    visible: true,
    isUserManaged: false,
    isEditable: false,
    settings: {
      baseLine: true,
      lastPlanned: false,
      actual: true,
      baseLineProgress: true,
      lastPlannedProgress: false,
      actualProgress: true,
    },
    type: 'custom',
    customizationType: 'admin-only',
  },

  // {
  //   id: 2,
  //   code: 'RAG_DETAIL',
  //   name: 'Detalle de avance por actividades',
  //   description: 'Listado detallado del avance de cada actividad dentro de los grupos del proyecto. Muestra el estado individual de las actividades, fechas programadas y reales, responsables asignados, y el porcentaje de ejecución alcanzado. Esta página proporciona una vista granular complementaria al resumen general.',
  //   visible: true,
  //   colorRowActivityGroup: '#B6F8FB',
  //   colorRowActivity: '#B6F8FB',
  //   colorRowSubactivity: '#87CC50',
  //   colorColTaskActivity: '#D0FCA7',
  //   isUserManaged: false,
  //   isEditable: false,
  //   type: 'custom',
  //   customizationType: 'admin-only',
  // },
]

export const defaultSections = [
  {
    id: 2,
    code: 'GENERAL',
    name: 'GENERAL',
    description: null,
    visible: false,
    hasAssociatedGroup: false,
    canDisableSection: false,
    numberOfExtraImages: 0,
    isUserManaged: true,
    documentType: null,
    userCanDefineLegend: false,
    isEditable: false,
    type: 'section',
    customizationType: 'user-editable',
  },
]

export const optionsDefaultSections = [
  {
    code: 'OC',
    name: 'CIVIL WORK',
    description: null,
  },
  {
    code: 'MM',
    name: 'MECHANICAL INSTALLATION',
    description: null,
  },
  {
    code: 'ME',
    name: 'ELECTRICAL INSTALLATION',
    description: null,
  },
  {
    code: 'LEV',
    name: 'EVACUATION LINE',
    description: null,
  },
  {
    code: 'SET',
    name: 'SET',
    description: null,
  },
  {
    code: 'BESS',
    name: 'BESS',
    description: null,
  },
  {
    code: 'GANTT',
    name: 'GANTT',
    description: null,
  },
]

// 'admin-only': solo el admin puede configurar.
// 'user-editable': visible para el usuario y este puede editarlo.
// 'none': no es personalizable en ningún caso.
export const sectionTemplate = {
  id: 0,
  code: null,
  name: null,
  description: null,
  visible: false,
  hasAssociatedGroup: true,
  canDisableSection: false,
  numberOfExtraImages: 0,
  isUserManaged: true,
  groupId: null,
  documentType: null,
  userCanDefineLegend: false,
  // Solo aplica a la sección GANTT: false = pagina PDF vertical, true = horizontal
  ganttLandscape: false,
  // GANTT: si es true, el usuario puede cambiar la orientación al generar; si no, usa la de config
  ganttUserCanChangeOrientation: false,
  isEditable: true,
  type: 'section',
  customizationType: 'user-editable', //'admin-only' | 'user-editable' | 'none',
}

export const pageTemplate = {
  id: 0,
  code: null,
  name: null,
  description: null,
  visible: false,
  isUserManaged: true,
  isEditable: true,
  settings: {},
  type: 'custom',
  customizationType: 'admin-only', //'admin-only' | 'user-editable' | 'none',
}
